import axios from "axios";

const API = axios.create({
  baseURL: "/api",
});

// attach token
API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");
  if (token) req.headers.Authorization = `Bearer ${token}`;
  return req;
});


// ===============================
// UPLOAD VISIT PROOFS
// ===============================
export const uploadVisitProofApi = (formData) =>
  API.post("/visit-proofs", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });


// ===============================
// GET PROOFS BY ACTIVITY
// ===============================
export const getVisitProofsApi = (activityId) =>
  API.get(`/visit-proofs/activity/${activityId}`);


// ===============================
// DELETE PROOF
// ===============================
export const deleteVisitProofApi = (id) =>
  API.delete(`/visit-proofs/${id}`);


// ===============================
// ADMIN: GET BY DATE ✅ ADDED
// ===============================
export const getAdminVisitProofsByDateApi = (date) =>
  API.get(`/visit-proofs/admin?date=${date}`);